const notifications = state => state.notifications

const upgradeNotifications = state => state.upgradeNotifications

const filteredNotifications = state => {
    if(_.isEmpty(state.notifications)) {
        return []
    }
    const dateFilter = _.uniq(state.notifications.map(item => moment(new Date(item.createdAt)).format('dddd, MMMM DD, YYYY') ))
    const filteredValue = dateFilter.map(item => {
        return {
            createdAt: item,
            list: state.notifications.filter(noti => item === moment(new Date(noti.createdAt)).format('dddd, MMMM DD, YYYY')  )
        }
    })
    return filteredValue
}

const filteredUpgradeNotifications = state => {
    if(_.isEmpty(state.upgradeNotifications)) {
        return []
    }
    const dateFilter = _.uniq(state.upgradeNotifications.map(item => moment(new Date(item.createdAt)).format('dddd, MMMM DD, YYYY')  ))
    const filteredValue = dateFilter.map(item => {
        return {
            createdAt: item,
            list: state.upgradeNotifications.filter(noti => item === moment(new Date(noti.createdAt)).format('dddd, MMMM DD, YYYY')  )
        }
    })
    return filteredValue
}

const notificationsLoading = state => state.notificationsLoading

const upgradeNotiMeta = state => state.upgradeNotiMeta

const systemNotiMeta = state => state.systemNotiMeta

export default {
  notifications,
  notificationsLoading,
  filteredNotifications,
  upgradeNotifications,
  filteredUpgradeNotifications,
  upgradeNotiMeta,
  systemNotiMeta
}